import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';

/* -------------------------------------------------------------------------------------------------------------- */
export function emailValidator(): ValidatorFn {
	return (control: AbstractControl): Record<string, any> | null => {
		const email = control.value;
		const valid = EmailValidator.isValidEmail(email);
		return valid ? null : {email: true};
	};
}

export function emailValidator2(control: FormControl) {
	const email = control.value;
	if (email.isEmptyString()) return null;
	let result = false;
	const emailRegEx = new RegExp('[^@\\s]+@[^@\\s]+\\.[^@\\s]+');
	result = emailRegEx.test(email);

	return result ? null : {invalidEmail: {value: email}};
}
/* -------------------------------------------------------------------------------------------------------------- */
export namespace EmailValidator {
	export const emailRegex = new RegExp('[^@\\s]+@[^@\\s]+\\.[^@\\s]+');

	export const isValidEmail = (email: string, validPlaceHolders?: string[]): boolean => {
		if (!email) return false;
		try {
			return emailRegex.tryTest(email) || validPlaceHolders?.find(ph => ph === email)?.length > 0;
		} catch (e) {
			return false;
		}
	};
}
